<template>
  <div>
    <app-spinner v-if="!schedule_own" />
    <template v-else>
      <app-schedule :schedule="schedule_own" />
    </template>
  </div>
</template>

<script>
import AppSchedule from '@/components/AppSchedule'

export default {
  name: 'TransferScheduleOwn',
  components: { AppSchedule },
  props: {
    schedule_own: Object
  },
}
</script>
